const STORAGE_KEY = 'mandarin-my-plate';

export const phrasePlateId = (phrase) =>
  `${phrase.english}::${phrase.spoken || phrase.mandarin}`;

export const loadPlatePhrases = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item) =>
        item &&
        typeof item.english === 'string' &&
        typeof item.mandarin === 'string' &&
        typeof item.spoken === 'string'
    );
  } catch {
    return [];
  }
};

export const savePlatePhrases = (phrases) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(phrases));
  } catch {
    // Quota / private mode — ignore; UI still works for the session.
  }
};
